<template>
  <b-modal
    hide-footer
    id="modal-add-role"
    ref="modal-add-role"
    size="xl"
    title="เพิ่มผู้ใช้งานเข้ากลุ่มสิทธิ์"
  >
    <div class="container">
      <b-overlay :show="showOverlay" rounded="sm">
        <b-card>
          <b-row>
            <b-card class="mt-2 col-12">
              <b-col cols="12">
                <SearchFilter
                  :mode="'UserModal'"
                  :autoSearch="false"
                  @handleSubmit="searchFilterSubmit"
                />
              </b-col>
            </b-card>

            <b-col cols="12" class="row">
              <b-col md="6" class="d-flex justify-content-center">
                <b-form-group
                  label="หน่วยงาน"
                  label-for="dep"
                  class="w-100 pl-2"
                >
                  <b-form-input
                    type="text"
                    :readonly="true"
                    v-model="departmentName"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6" class="d-felx justify-content-end">
                <b-form-group label="สิทธิ์" label-for="role">
                  <vue-select
                    label="text"
                    v-model="roleSelect"
                    :options="roles"
                    @input="selectOnInput"
                    :clearable="false"
                  />
                </b-form-group>
              </b-col>
            </b-col>

            <b-col cols="12">
              <CommonTable
                @handle-select="onSelectChange"
                @handleOverlay="setOverlay"
                ref="tableCommon"
              >
              </CommonTable>
            </b-col>
          </b-row>
          <footer
            id="modal-transfer___BV_modal_footer_"
            class="modal-footer d-flex justify-content-between"
          >
            <button
              type="button"
              class="btn btn-secondary"
              block
              @click="onCancel"
            >
              ยกเลิก
            </button>
            <button
              type="button"
              class="btn btn-primary"
              block
              @click="onSubmit"
            >
              เพิ่มผู้ใช้งาน
            </button>
          </footer>
        </b-card>
      </b-overlay>
    </div>
  </b-modal>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BModal,
  BButton,
  BFormTextarea,
  BOverlay,
  BCard,
} from "bootstrap-vue";

import VueSelect from "vue-select";

import CommonTable from "./commonTableModal";
import SearchFilter from "./SearchFilter";
import * as roleStore from "@/store/api/role/index.js";
import * as departmentRoleStore from "@/store/api/role/departmentRole.js";

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BModal,
    BFormTextarea,
    BCard,
    BOverlay,
    VueSelect,
    CommonTable,
    SearchFilter,
  },
  props: {
    departmentId: null,
    departmentName: null,
    roleId: null,
  },
  data() {
    return {
      datasuggest: [],
      filteredOptions: [],
      inputProps: {
        id: "companyName",
        class: "form-control",
        placeholder: "ผู้ประกอบธุรกิจ (ผู้ถูกร้องทุกข์)",
      },
      limit: 10,
      selects: [],
      showOverlay: false,
      roleSelect: null,
      roles: [],
    };
  },
  mounted() {
    this.getRoles();
  },
  methods: {
    onOpenModal() {
      const _this = this;
      if (this.roleId !== null) {
        const selectedRole = this.roles.find((value) => {
          return value.roleId == _this.roleId;
        });

        _this.roleSelect = selectedRole;
      }
    },
    getRoles() {
      var _this = this;
      roleStore
        .search({ isActive: true })
        .then(function(response) {
          // handle success
          _this.roles = response.data.data.map((value) => {
            return {
              value: value.roleId,
              text: value.roleName,
            };
          });
          console.log("roles", _this.roles);
          _this.roleSelect = _this.roles[0];
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        })
        .then(function() {
          // always executed
          console.log("GET");
          _this.$emit("handleOverlay", false);
        });
    },
    setOverlay(isShow) {
      this.showOverlay = isShow;
    },
    searchFilterSubmit(params) {
      this.$refs.tableCommon.onSearchSubmit(params);
    },
    onSubmit() {
      var _this = this;

      if (this.selects.length < 1) {
        this.$bvToast.toast("กรุณาเลือกผู้ใช้งานที่จะเพิ่มเข้ากลุ่มสิทธิ์", {
          title: `กรุณาเลือกผู้ใช้งานที่จะเพิ่มเข้ากลุ่มสิทธิ์อย่างน้อย 1 รายการ`,
          variant: "danger",
          solid: false,
        });
        return;
      }

      const userIds = this.selects.map((value) => {
        return value.userId;
      });

      const params = {
        departmentId: this.departmentId,
        roleId: this.roleSelect.value,
        userIds: userIds,
      };

      departmentRoleStore
        .addItem(params)
        .then(function(response) {
          // handle success
          if (response.data.success === true) {
            _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
              title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
              variant: "success",
              solid: false,
            });

            _this.$emit("handle-submit");
            _this.$refs["modal-add-role"].hide();
          } else {
            _this.$bvToast.toast("เกิดข้อผิดพลาด", {
              title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
              variant: "danger",
              solid: false,
            });
          }
        })
        .catch(function(error) {
          _this.$bvToast.toast("เกิดข้อผิดพลาด", {
            title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
            variant: "danger",
            solid: false,
          });
        })
        .then(function() {
          // always executed
          console.log("GET");
          _this.$emit("handleOverlay", false);
        });
      console.log(this.selects, this.departmentId, this.roleSelect.value);
    },
    onCancel() {
      this.$refs["modal-add-role"].hide();
    },
    onSelectChange(selects) {
      this.selects = selects;
    },
    selectOnInput() {
      this.$forceUpdate();
    },
  },
};
</script>

<style></style>